import React from 'react';
import { useScript } from '../context/ScriptContext';

const Hero: React.FC = () => {
  const { t } = useScript();

  return (
    <header
      className="hero"
      // Background set via inline style with stable /resource/ URL so it
      // matches the <link rel="preload" as="image"> in index.html. CSS-side
      // url() would be webpack-hashed and the preload wouldn't apply.
      style={{
        backgroundImage:
          "linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0)), url(/resource/slika.jpg)",
      }}
    >
      {/* Mobile background layer — rendered as a real element so we can
          use a runtime URL (inline style) instead of CSS url() which
          webpack's css-loader cannot resolve for /public assets. */}
      <div
        className="hero-mobile-bg"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0)), url(/resource/slika.jpg)",
        }}
        aria-hidden="true"
      />
      {/* <div className="hero-subtitle">{t("Долина јоргована")}</div> */}
      <h1>
        <span className="hero-line1">{t("Српски православни манастир Светих Благовести")}</span>
        <span className="hero-line2">{t("Градац")}</span>
      </h1>
    </header>
  );
};

export default Hero;

